import { client } from '@onefootprint/fetch-hosted';

const setHeader = (clientVersion: string): void => {
  client.setConfig({ headers: { 'X-Fp-Client-Version': clientVersion } });
};

// Returns true when the header was set from the URL, so the caller knows
// not to overwrite it with a less-specific value from Postmate later.
export const setClientVersionHeaderFromUrl = (): boolean => {
  if (typeof window === 'undefined') return false;
  const urlVersion = new URLSearchParams(window.location.search).get('sdk_version');
  if (urlVersion) {
    setHeader(urlVersion);
    return true;
  }
  return false;
};

// Old footprint-js/footprint-js-legacy bundles send a bare semver through
// Postmate with no package name. Those are already in the wild and can't be
// upgraded, so prefix footprint-js — the only SDK that reaches idv adapters.
export const setClientVersionHeaderFromPostmate = (sdkVersion?: string): void => {
  if (!sdkVersion) return;
  const clientVersion = sdkVersion.includes(':') ? sdkVersion : `@onefootprint/footprint-js:${sdkVersion}:verify_v1`;
  setHeader(clientVersion);
};
